.root {
  height: 100%;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(circle at top left, rgba(61, 104, 255, 0.22), transparent 32%),
    linear-gradient(180deg, #101827 0%, #0b1220 100%);
  color: #fff;
}

.rootCollapsed {
  align-items: stretch;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  height: 64px;
  flex-shrink: 0;
}

.rootCollapsed .brand {
  justify-content: center;
  height: 64px;
  padding: 12px 8px;
}

.brandToggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
}

.brandToggle:hover .brandToggleIcon,
.brandToggle:focus-visible .brandToggleIcon {
  filter: brightness(1.12);
}

.brandToggle:focus-visible {
  outline: 2px solid rgba(96, 165, 250, 0.85);
  outline-offset: 2px;
}

.scroll {
  flex: 1;
  min-height: 0;
}

.navGroup {
  margin-bottom: 20px;
}

.rootCollapsed .navGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
}

/* Tooltip wrappers are inline by default — force a single icon column. */
.rootCollapsed .navGroup > * {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-shrink: 0;
}

.navGroupTitle {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
  padding: 0 12px 8px;
}

.navItem {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  gap: 12px;
  transition: background 120ms ease, color 120ms ease;
  text-decoration: none;
  margin-bottom: 4px;
}

.navItemWrap {
  display: flex;
  justify-content: center;
  width: 100%;
}

.navItemCollapsed {
  justify-content: center;
  padding: 0;
  width: 44px;
  min-width: 44px;
  max-width: 44px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
}

.navItem:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.navItemActive {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.35);
}

.userFooter {
  margin-top: auto;
  padding: 16px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 13px;
}

.rootCollapsed .userFooter {
  display: flex;
  justify-content: center;
  padding: 12px 8px;
}

.userName {
  font-weight: 700;
  line-height: 1.35;
}

.userMeta {
  display: block;
  opacity: 0.75;
  line-height: 1.35;
  margin-top: 2px;
}

.contextLink {
  display: inline-flex;
  margin-top: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.contextLinkCollapsed {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 42px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.contextLinkCollapsed:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}
